import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Helmet from "react-helmet";
import Button from "react-bootstrap";
import Moment from "moment";
import { useHistory, useParams } from "react-router-dom";
//services
import { getClaim } from "../services/claimService";
import { defaultTitle } from "../config";
//custom hooks
import {
  getDeliveryConcern,
  reopenDeliveryConcern,
} from "../services/deliveryConcernService";
import useForm from "../hooks/useForm";
import postDeliveryConcern from "./PostDeliveryConcern";
import { OrderInfoDisplay } from "./Utility/OrderInfoDisplay";

const InvoiceTemplate = {
  invoiceNumber: "",
  isPurchasingInsurance: false,
  declaredValue: "",
};
const ViewClaimRework = ({ setLoading }) => {
  const [reopenDeliveryConcern, setReopenDeliveryConcern] = useState(true);

  const [customerSelectionType, setCustomerSelectionType] =
    useState("existing");
  const [cityAndState, setCityAndState] = useState("");
  const [customer, setCustomer] = useState("");
  const [customerInfo, setCustomerInfo] = useState({});

  const { id: deliveryConcernId } = useParams();
  const [openDeliveryConcern, setOpenDeliveryConcern] = useState(false);
  //STATES
  const [formValues, setFormValues] = useForm({
    problemDescription: "",
  });
  const [deliveryConcern, setDeliveryConcern] = useState();
  const [accountNumberToLookup, setAccountNumberToLookup] = useState("");
  const handleChangeAccountNumber = (e) => {
    setAccountNumberToLookup(e.target.value);
  };
  const [customerToShow, setCustomerToShow] = useState();
  const [showCustomerByAccount, setShowCustomerByAccount] = useState(false);
  const lookupAccount = () => {
    setShowCustomerByAccount(true);
    setCustomerToShow(customersWithAccountNumbers[accountNumberToLookup]);
  };
  const { id: claimId } = useParams();
  const history = useHistory();

  const [claim, setClaim] = useState();

  const [customersWithAccountNumbers, setCustomersWithAccountNumbers] =
    useState({
      1: {
        name: "California Mechanic with an account TM",
        address: "LA",
        email: "wechargeperminuteforparking@california.gov",
        phone: "915-555-5555",
      },
      2: {
        name: "We Killed the Dragon Car Rentals",
        address: "Lumby",
        email: "chosenonescape@rsprivateservers.com",
        phone: "925-555-5555",
      },
      3: {
        name: "__f0rtnitepro___52",
        address: "Tencent HQ",
        email: "contact@epicgames.com",
        phone: "935-555-5555",
      },
    });
  const [orderInfo, setOrderInfo] = useState({ comments: "" });
  const handleChangeOrderInfo = (e) => {
    const { name, value } = e.target;
    setOrderInfo({ ...orderInfo, [name]: value });
  };
  const [valuationRate, setValuationRate] = useState(0.006); //*******REPLACE THIS WITH VALUE RECEIVED FROM BACKEND - MAKE SURE TO ADJUST FOR DECIMAL PLACES - IT IS SUPPOSED TO BE .6% in the end!!!!!************
  const [invoices, setInvoices] = useState([{ ...InvoiceTemplate }]);
  const handleChangeInvoiceNumber = (e, invoiceIndex) => {
    // console.log(
    //   "changing invoice number of " + invoiceIndex + " to: " + e.target.value
    // );
    let updatedInvoices = [...invoices];
    //probably need to update this to spread the object into a new object but not 100% sure since we already spread the whole array.
    //NEEED to look into this **********
    updatedInvoices[invoiceIndex].invoiceNumber = e.target.value;
    setInvoices(updatedInvoices);
  };

  //=================================END INVOICE LIST SECTION==========================================================//

  const handleSelectCityAndState = (e) => {
    setCustomer(""); //when we change city/state, reset customer to blank
    setCityAndState(e.target.value);
  };
  const handleSelectCustomer = (e) => {
    if (e.target.value === "") {
      // if they select "Select Customer"
      setCustomer("");
    } else {
      // take the customer out of the list
      //update the list of customers
      setCustomer(0); //set the customer index to 0, as we moved the selected customer to that index, it will always be 0 but we set it to 0 here because if they select "Select Customer" we set it to "" (maybe we can omit that later)
    }
  };
  const handleChangeCustomerSelectionType = (e) => {
    setCustomerSelectionType(e.target.value);
  };
  useEffect(() => {
    (async () => {
      setLoading(true);

      try {
        const { data: foundClaim } = await getClaim(claimId);

        setClaim(foundClaim);

        setLoading(false);
      } catch (ex) {
        setLoading(false);
      }
    })();
  }, [claimId, history, setLoading]);
  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const { data: deliveryConcernId } = await postDeliveryConcern({
        deliveryConcernId,
        ...formValues,
      });

      history.push(`/delivery-concern/${deliveryConcernId}`);
    } catch (ex) {}
  };
  const reopenDC = () => {
    setReopenDeliveryConcern(!reopenDeliveryConcern);
  };
  return (
    <>
      <Helmet>
        <title></title>
      </Helmet>
      {claim && (
        <div className="container paper-panel form-container">
          {/* ****MAKE MODAL FOR INVOICE LIST DELETION */}
          <div className="row">
            <div className="col form-header">
              <h1>Claim #{claim.claimNo}</h1>
              <p>
                {/* <span className="required-star">*</span> denotes a required field. */}
              </p>
            </div>
          </div>
          <div className="container paper-panel sub-panel">
            <div className="row sub-panel-header align-items-center">
              <div className="col-12">
                <label className="font-weight-bold">Claim Information</label>
              </div>
            </div>
            <div className="row p-2">
              <OrderInfoDisplay
                label="Claim Reference #"
                info={claim.claimNo}
              />
              <OrderInfoDisplay label="Claim Type" info={claim.type} />
              <OrderInfoDisplay label="Customer" info={claim.customer} />
              <OrderInfoDisplay label="Route" info={claim.route} />
              <OrderInfoDisplay label="Part Number" info={claim.partNo} />
              <OrderInfoDisplay label="Part Description" info={claim.pDesc} />
              <OrderInfoDisplay label="Claim Amount" info={claim.amount} />
            </div>
          </div>
          <div className="container paper-panel sub-panel">
            <div className="row sub-panel-header align-items-center">
              <div className="col-6">
                <label className="font-weight-bold">Order Information</label>
              </div>
            </div>
            <div className="row p-2">
              <OrderInfoDisplay label="Delivery ID" info={claim.deliveryId} />
              <OrderInfoDisplay
                label="Invoice Number"
                info={claim.invoiceNumber}
              />
              <OrderInfoDisplay label="Customer Name" info={claim.customer} />
              <OrderInfoDisplay label="Dealer" info={claim.dealer} />
              <OrderInfoDisplay label="Route" info={claim.route} />
              <OrderInfoDisplay
                label="Ship Date"
                infoType="date"
                info={claim.cDate}
              />
            </div>
          </div>
          <div className="container paper-panel sub-panel">
            <div className="row sub-panel-header align-items-center"></div>
            <div className="row p-2">
              <div className="col-lg-6">
                <label className="font-weight-bold sub-panel-header mb-4">
                  Claim Status
                </label>
                <div
                  style={{
                    maxWidth: 400,
                    paddingLeft: 20,
                    paddingBottom: 0,
                  }}
                >
                  <table className="table table sm">
                    <tbody>
                      <tr>
                        <td>
                          <div>
                            Approved
                            <br />
                            <input
                              type="checkbox"
                              checked={claim.stat === "A"}
                              readOnly
                            />
                          </div>
                        </td>
                        <td>
                          <div>
                            Denied
                            <br />
                            <input
                              type="checkbox"
                              checked={claim.stat === "D"}
                              readOnly
                            />
                          </div>
                        </td>
                        <td>
                          <div>
                            Canceled
                            <br />
                            <input
                              type="checkbox"
                              checked={claim.stat === "C"}
                              readOnly
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td scope="col"></td>
                        <td scope="col"></td>
                        <td scope="col"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="col-lg-6">
                <label className="font-weight-bold sub-panel-header mb-3">
                  Comments
                </label>
                <p>{claim?.comment}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewClaimRework;
